import { AppConst } from 'constants/appConst';
import type { AcctStateType } from 'stores/atoms/acctState';

export interface PlanStatus {
  isTrial: boolean;
  isExpiredPlan: boolean;
}

/**
 * acctState.company.plan から isTrial / isExpiredPlan を導出する。
 * isTrial: planId === trial かつ 期限切れでない
 * isExpiredPlan: plan.isExpired そのまま
 */
export function derivePlanStatus(plan: NonNullable<AcctStateType['company']>['plan']): PlanStatus {
  const isExpiredPlan = plan.isExpired;
  const isTrial = plan.planId === AppConst.planId.trial && !isExpiredPlan;
  return { isTrial, isExpiredPlan };
}
